import { ColumnConfiguration } from "src/app/common/interfaces/column-configuration.interface";

export const WarrantyColumnSettings: ColumnConfiguration[] = [
    {
        columnId: 'warrantyType',
        headerText: 'Tipo',
        defaultIfEmpty: '-',
        type: 'text',
        isSortable: true,
    },
    {
        columnId: 'insuranceCompany',
        headerText: 'Aseguradora',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'createdAt',
        headerText: 'Solic.',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'tender',
        headerText: 'Lic.',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'code',
        headerText: 'Código',
        defaultIfEmpty: '',
        type: 'anchor',
        isSortable: true,
        anchorUrlTemplate: 'https://garantiaschilecompra.cl/client/document/downloaddocument?c={c}',
        urlParams:{c: 'code'}
    },
    {
        columnId: 'amount',
        headerText: 'Monto',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    },
    {
        columnId: 'amountType',
        headerText: 'Moneda',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: false,
    },
    {
        columnId: 'cost',
        headerText: 'Comisión',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    },
    {
        columnId: 'nameTenderBuyer',
        headerText: 'Mandante',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'requestDate',
        headerText: 'Desde',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'endDate',
        headerText: 'Hasta',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'status',
        headerText: 'Estado',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'comisionPago',
        headerText: 'Comisión Pagada',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    },
    {
        columnId: 'tasa',
        headerText: 'Tasa (%)',
        defaultIfEmpty: '',
        type: 'percentage',
        isSortable: true
    },
    {
        columnId: 'indiceRec',
        headerText: 'Indice Recaud.',
        defaultIfEmpty: '',
        type: 'decimal',
        isSortable: true
    },
    {
        columnId: 'porcDesc',
        headerText: 'Descuento (%)',
        defaultIfEmpty: '',
        type: 'percentage',
        isSortable: true
    },
    {
        columnId: 'insuranceBroker',
        headerText: 'Corredor',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'isForBuilding',
        headerText: 'Construcción',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'contractAmount',
        headerText: 'Tamaño Contrato',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    }
];

export const PendingWarrantyColumnSettings: ColumnConfiguration[] = [
    {
        columnId: 'warrantyType',
        headerText: 'Tipo',
        defaultIfEmpty: '-',
        type: 'text',
        isSortable: true,
    },
    {
        columnId: 'insuranceCompany',
        headerText: 'Aseguradora',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'createdAt',
        headerText: 'Solic.',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'tender',
        headerText: 'Lic.',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'amount',
        headerText: 'Monto',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    },
    {
        columnId: 'amountType',
        headerText: 'Moneda',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: false,
    },
    {
        columnId: 'cost',
        headerText: 'Comisión',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    },
    {
        columnId: 'nameTenderBuyer',
        headerText: 'Mandante',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'requestDate',
        headerText: 'Desde',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'endDate',
        headerText: 'Hasta',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'tasa',
        headerText: 'Tasa (%)',
        defaultIfEmpty: '',
        type: 'percentage',
        isSortable: true
    },
    {
        columnId: 'insuranceBroker',
        headerText: 'Corredor',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'isForBuilding',
        headerText: 'Construcción',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    }
];

export const AwaitingPaymentWarrantyColumnSettings: ColumnConfiguration[] = [
    {
        columnId: 'warrantyType',
        headerText: 'Tipo',
        defaultIfEmpty: '-',
        type: 'text',
        isSortable: true,
    },
    {
        columnId: 'insuranceCompany',
        headerText: 'Aseguradora',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'createdAt',
        headerText: 'Solic.',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'tender',
        headerText: 'Lic.',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'amount',
        headerText: 'Monto',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    },
    {
        columnId: 'amountType',
        headerText: 'Moneda',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: false,
    },
    {
        columnId: 'cost',
        headerText: 'Comisión',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    },
    {
        columnId: 'nameTenderBuyer',
        headerText: 'Mandante',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'requestDate',
        headerText: 'Desde',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'endDate',
        headerText: 'Hasta',
        defaultIfEmpty: '',
        type: 'date',
        isSortable: true
    },
    {
        columnId: 'tasa',
        headerText: 'Tasa (%)',
        defaultIfEmpty: '',
        type: 'percentage',
        isSortable: true
    },
    {
        columnId: 'insuranceBroker',
        headerText: 'Corredor',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'isForBuilding',
        headerText: 'Construcción',
        defaultIfEmpty: '',
        type: 'text',
        isSortable: true
    },
    {
        columnId: 'contractAmount',
        headerText: 'Tamaño Contrato',
        defaultIfEmpty: '',
        type: 'currency',
        isSortable: true
    }
];